import * as Yup from "yup";
import http from "services/httpService";
import useUser from "hooks/useUser";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email ID")
    .required("Email is required!"),
  password: Yup.string().required("Password is required!"),
});

const initialValues = {
  email: "",
  password: "",
};

function useLoginValidation() {
  const { setUser } = useUser();
  const loginEmployer = async ({ email, password }, setLoading, navigate, setFieldError) => {
    setLoading(true);
    try {
      let { data } = await http.post("/phone/verify_employer_login/", {
        email: email,
        password: password,
      });
      data = data.data;
      setUser(data);
      setLoading(false);
      navigate("/v1")
      //   const about = {
      //     name: data["company"] && data["company"]["company_name"],
      //     pincode: data["company"] && data["company"]["pincode"],
      //     numberOfEmployees:
      //       data["company"] && data["company"]["number_of_employees"],
      //     email: data["email"],
      //   };
      //   localStorage.setItem("uuid", data.id);
      //   const options = ["GMC", "GMC_M", "GPA", "GTL"];
      //   if (data.company.flex) {
      //     console.log("IN");
      //     localStorage.setItem("isFlex", true);
      //   } else if (options.includes(data.b_type)) {
      //     localStorage.setItem("flow", data.b_type);
      //   }
      //   localStorage.setItem("about", JSON.stringify(about));
      //   localStorage.removeItem("navigatingFrom");
      //   localStorage.setItem("marketplace_city", data["marketplace_city"]);
      //   localStorage.setItem("businessAccount", true);
      //   localStorage.setItem(
      //     "companyId",
      //     data["company"] && data["company"]["id"]
      //   );
      //   const loggingInFor = localStorage.getItem("logginginfor");
      //   if (data["company"] && data["company"]["userplan_id"]) {
      //     localStorage.setItem("userplan_id", data["company"]["userplan_id"]);
      //     localStorage.setItem("token", data.token);
      //     if (loggingInFor === "insurancepayment") {
      //       history.push("/business/payment");
      //       return;
      //     }
      //     history.push("/business/dashboard");
      //   } else if (
      //     data["company"] &&
      //     !data["company"]["userplan_id"] &&
      //     data["company"]["employee_collection_required"]
      //   ) {
      //     localStorage.setItem("token", data.token);
      //     history.push("/business/employee-registration-dashboard");
      //   } else {
      //     setLoading(false);
      //   }
    } catch (ex) {
      setFieldError("password", "Invalid credentials");
      setLoading(false);
    }
  };
  return {
    initialValues,
    validationSchema,
    loginEmployer,
  };
}

export default useLoginValidation;
